'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _highlightJs = require('highlight.js');

var _highlightJs2 = _interopRequireDefault(_highlightJs);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var Highlight = (function (_React$Component) {
    _inherits(Highlight, _React$Component);

    function Highlight() {
        _classCallCheck(this, Highlight);

        _get(Object.getPrototypeOf(Highlight.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Highlight, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.highlightCode();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.highlightCode();
        }
    }, {
        key: 'highlightCode',
        value: function highlightCode() {
            var domNode = _reactDom2['default'].findDOMNode(this);
            var nodes = domNode.querySelectorAll('pre code');

            var i = undefined;
            for (i = 0; i < nodes.length; i++) {
                _highlightJs2['default'].highlightBlock(nodes[i]);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props;
            var children = _props.children;
            var className = _props.className;
            var element = _props.element;
            var innerHTML = _props.innerHTML;

            var Element = element ? _react2['default'].DOM[element] : null;

            if (innerHTML) {
                if (!Element) {
                    Element = _react2['default'].DOM.div;
                }

                return Element({ dangerouslySetInnerHTML: { __html: children }, className: className || null }, null);
            } else {
                if (Element) {
                    return Element({ className: className }, children);
                } else {
                    return _react2['default'].createElement(
                        'pre',
                        null,
                        _react2['default'].createElement(
                            'code',
                            { className: className },
                            children
                        )
                    );
                }
            }
        }
    }]);

    return Highlight;
})(_react2['default'].Component);

Highlight.defaultProps = {
    innerHTML: false,
    className: null,
    element: null
};

exports['default'] = Highlight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-highlight/lib/index.js
// module id = 1190
// module chunks = 0